import tw from 'tailwind-styled-components';
import { Title as TitleBase } from '@bidalihq/ui';
import NextImage from 'next/image';

import SideScroller from '@/components/side-scroller';
import Section from '@/components/section';

const Item = tw.div`
  flex
  flex-col
  items-star

  lg:aspect-square
  lg:w-auto
`;

const Card = tw.div`
  bg-white
  rounded-2xl
  w-full
  h-full
  shadow-lg

  lg:aspect-square

  lg:h-auto
`;

const CardContent = tw.div`
  p-8

  lg:p-12
  lg:pt-8
`;

const Title = tw(TitleBase)`
  text-center
  font-inter
  py-8

  lg:pb-20
  xl:text-8xl
`;

const ImageContainer = tw.div`
  relative
  rounded-t-2xl
  aspect-video
  overflow-hidden
  w-full
`;

const Image = tw(NextImage)`
  object-cover
`;

const CardTitle = tw.h3`
  text-2xl
  mb-6

  lg:text-4xl
  lg:mb-8
`;

const CardDescription = tw.p`
  text-gray-700
  text-lg

  lg:text-2xl
`;

const steps = [
  {
    title: 'Seamless Integration',
    description: 'Effortlessly meld our reward engine with your business toolkit.',
    image: '/images/design.jpg'
  },
  {
    title: 'Tailored Incentives',
    description: 'Craft unique rewards that resonate with your brand\'s ambitions.',
    image: '/images/terms.jpg'
  },
  {
    title: 'Automatic Uplift',
    description: 'Watch rewards flow as your team or clientele hit milestones.',
    image: '/images/design.jpg'
  }
];


export default function HowItWorks () {
  return (
    <div className="overflow-hidden bg-slate-50">
      <Section
        style={{
          maskImage: 'linear-gradient(to right, white calc(100% - (100vw - 1280px) / 2), transparent)',
          maskComposite: 'subtract',
          maskMode: 'alpha'
        }}
      >
        <Title>How it works</Title>
        <SideScroller itemWidth={0.5}>
          {steps.map((step, index) => (
            <Item key={index}>
              <Card>
                <ImageContainer>
                  <Image src={step.image} alt={step.title} fill sizes="30vw" />
                </ImageContainer>
                <CardContent>
                  <CardTitle>{step.title}</CardTitle>
                  <CardDescription>{step.description}</CardDescription>
                </CardContent>
              </Card>
            </Item>
          ))}
        </SideScroller>
      </Section>
    </div>
  );
}
